"use strict";

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/helpers/auth");

var _getPageTitle = _interopRequireDefault(require("@/helpers/get-page-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/', 'Login', 'Logout', 'PasswordReminder', 'PasswordReset', '/404', '/401', 'Home', '/profil', '/version']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(to, from, next) {
    var hasToken, hasRole, acl, user;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title


            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 38;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });

            _nprogress.default.done();

            _context.next = 36;
            break;

          case 9:
            _context.next = 11;
            return _store.default.dispatch('app/messageNavbar');

          case 11:
            // determine whether the user has obtained his permission roles through getUserInfo
            hasRole = _store.default.getters && _store.default.getters.user && _store.default.getters.user.key_role !== '';

            if (!hasRole) {
              _context.next = 17;
              break;
            }

            acl = _store.default.getters.permission.acl || [];

            if (!acl.includes(to.name) && !whiteList.includes(to.path)) {
              next({
                path: '/401'
              });
            } else {
              next();
            }

            _context.next = 36;
            break;

          case 17:
            _context.prev = 17;
            _context.next = 20;
            return _store.default.dispatch('user/getUserInfo');

          case 20:
            user = _context.sent;
            _context.next = 23;
            return _store.default.dispatch('permission/getPermission', user);

          case 23:
            _context.next = 25;
            return _store.default.dispatch('permission/generateRoutes', user);

          case 25:
            _context.next = 27;
            return _store.default.dispatch('workflow/initSocieteParams', user);

          case 27:
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next(_objectSpread({}, to, {
              replace: true
            }));
            _context.next = 36;
            break;

          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](17);
            _context.next = 34;
            return _store.default.dispatch('user/resetToken');

          case 34:
            // Message.error(error || 'Has Error')
            next("/login?redirect=".concat(to.path));

            _nprogress.default.done();

          case 36:
            _context.next = 39;
            break;

          case 38:
            /* has no token */
            if (whiteList.indexOf(to.name) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));

              _nprogress.default.done();
            }

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 30]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});